'use strict';

/**
 * GTM dataLayer interactions migrated from Custom HTML tags (parity with previous GTM triggers).
 * After go-live, unpublish the corresponding GTM tags to avoid duplicate events.
 */

var $ = window.jQuery || window.$;

function ensureDataLayer() {
    window.dataLayer = window.dataLayer || [];
}

function push(payload) {
    ensureDataLayer();
    window.dataLayer.push(payload);
}

/** Mirrors GTM: Click URL with domain stripped for nordic TLDs */
function breadcrumbLabelFromHref(href) {
    if (!href) {
        return '';
    }
    return String(href).replace(/^https?:\/\/.*\.(?:com|dk|se|fi|no)\//i, '');
}

function pagePathLabel() {
    return window.location.pathname || '';
}

function isNewsletterSignupControl(el) {
    var c = (el && el.className) ? String(el.className) : '';
    if (!c) {
        return false;
    }
    return (
        (/\bnewsletter-subscribe\b/.test(c) && /\bbutton--black\b/.test(c)) ||
        (/\bnewsletter-form-subscribe\b/.test(c) && /\bbutton--yellow\b/.test(c)) ||
        (/\bnewsletter-form-subscribe\b/.test(c) && /\bbutton--black\b/.test(c))
    );
}

var POPULAR_SEARCH_EXCLUSION = 'div.popular-search-dropdown-links > ul.popular-search-dropdown-list > li.popular-search-dropdown-list-li > a.suggestion-item';

function initDelegatedClickHandlers() {
    $(document).on('click', '[class*="breadcrumb-item"]', function (e) {
        var el = e.currentTarget;
        var a = el.tagName === 'A' ? el : $(el).closest('a')[0];
        var href = a && a.href ? a.href : '';
        push({
            event: 'pageInteraction',
            eventInfo: {
                category: 'page interactions',
                action: 'breadcrumbs click',
                label: breadcrumbLabelFromHref(href)
            }
        });
    });

    $(document).on('click', 'button, a, [role="button"]', function (e) {
        if (!isNewsletterSignupControl(e.currentTarget)) {
            return;
        }
        push({
            event: 'newsletterSignup',
            eventInfo: {
                category: 'Newsletter',
                action: 'Signup success',
                label: pagePathLabel()
            }
        });
    });

    $(document).on('click', 'div.top-categories > ul.top-categories-ul > li.top-categories-list > *', function (e) {
        var text = $(e.currentTarget).text().trim() || '';
        push({
            event: 'pageInteraction',
            eventInfo: {
                category: 'page interactions',
                action: 'button click',
                label: text
            }
        });
    });

    $(document).on('click', '.product-tile-brand', function (e) {
        if ($(e.target).closest(POPULAR_SEARCH_EXCLUSION).length) {
            return;
        }
        var text = $(e.currentTarget).text().trim() || '';
        push({
            event: 'pageInteraction',
            eventInfo: {
                category: 'page interactions',
                action: 'brand click',
                label: text
            }
        });
    });

    $(document).on('click', '.icon-arrow-left-right', function () {
        push({
            event: 'pageInteraction',
            eventInfo: {
                category: 'page interactions',
                action: 'image click',
                label: 'product image arrow click'
            }
        });
    });

    $(document).on('click', 'div.product-recommendation > div.product-recommendation-grid > div.product', function (e) {
        if ($(e.target).closest('div.product-tile > div.product-tile-CTA').length) {
            return;
        }
        var $tile = $(e.currentTarget);
        var altLabel = $(e.target).closest('[alt]').attr('alt')
            || $tile.find('img').first().attr('alt')
            || '';
        push({
            event: 'ppSuggestionProduct',
            eventInfo: {
                category: 'page interactions',
                action: 'product suggestion',
                label: altLabel
            }
        });
    });

    $(document).on('click', '#product-tabs > .tabs-header > *, .product-tabs > .tabs-header > *', function (e) {
        var label = (e.currentTarget.innerText || '').trim();
        push({
            event: 'pageInteraction',
            eventInfo: {
                category: 'page interactions',
                action: 'tab click',
                label: label
            }
        });
    });

    $(document).on('click', 'img.swatch-image', function () {
        push({
            event: 'pageInteraction',
            eventInfo: {
                category: 'page interactions',
                action: 'tab click',
                label: 'product thumbnail'
            }
        });
    });
}

/**
 * Call after .slick-product-carousel.mobile is initialized (PDP).
 */
function bindMobileProductCarouselSwipe() {
    var $m = $('.slick-product-carousel.mobile');
    if (!$m.length) {
        return;
    }
    $m.off('swipe.gtmDataLayer').on('swipe.gtmDataLayer', function () {
        push({
            event: 'pageInteraction',
            eventInfo: {
                category: 'page interactions',
                action: 'image click',
                label: 'product image swipe mobile'
            }
        });
    });
}

/**
 * Call after .slick-product-carousel.desktop is initialized (PDP / Quick View).
 * Uses slick's "swipe" event (fired only on real swipe gestures) instead of a
 * generic image click, so the GTM event reflects an actual user swipe.
 */
function bindDesktopProductCarouselSwipe() {
    var $d = $('.slick-product-carousel.desktop');
    if (!$d.length) {
        return;
    }
    $d.off('swipe.gtmDataLayer').on('swipe.gtmDataLayer', function () {
        push({
            event: 'pageInteraction',
            eventInfo: {
                category: 'page interactions',
                action: 'image click',
                label: 'product image swipe desktop'
            }
        });
    });
}

function init() {
    initDelegatedClickHandlers();
}

module.exports = init;
module.exports.bindMobileProductCarouselSwipe = bindMobileProductCarouselSwipe;
module.exports.bindDesktopProductCarouselSwipe = bindDesktopProductCarouselSwipe;
module.exports.push = push;
